import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Removes the Content-Type header for FormData requests so the browser can
 * automatically set multipart/form-data with the correct boundary.
 * Must be registered AFTER authInterceptor in app.config.ts.
 */
export const formDataInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.body instanceof FormData) {
    const modifiedReq = req.clone({
      headers: req.headers.delete('Content-Type'),
    });
    return next(modifiedReq);
  }
  return next(req);
};
